import { queryByFetch } from './io';
import { Promise } from 'es6-promise';
import types from '../store/types';
import store from '../store/store';
import { IdHelper, IMtoolValue, IJourneyItem, IAdminToolPanel } from './';
export class AdminToolPanelHelper {

    /**
  *  Add or upgrade a panel in the state
  * @static
  * @memberOf AdminToolPanelHelper
  */
    public static AddOrUpdatePanel(panel: IAdminToolPanel) {
        store.dispatch({
            type: types.ADD_OR_UPDATE_PANEL,
            panel: panel
        });
    }

    /**
 * Format a date into a formatted string
 * @static
 * @memberOf AdminToolPanelHelper
 */
    public static FormatDate(date: any): string {
        let monthNames: string[] = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        let day: string = date.getDate();
        let monthIndex: number = date.getMonth();
        let year: string = date.getFullYear();
        let hours: string = date.getHours();
        let mins: string =  date.getMinutes();
        mins += parseInt(mins) < 10 ? '0':'';

        return day + ' ' + monthNames[monthIndex] + ' ' + year + ' ' + hours + ':' + mins;
    }
    /**
    * Get search filters from the state
    * @static
    * @memberOf AdminToolPanelHelper
    */
    public static GetSearchFilters(panel: IAdminToolPanel): string {

        return panel && panel.searchFilter ? panel.searchFilter : null;
    }

    /**
   * Get is loading from the state
   * @static
   * @memberOf AdminToolPanelHelper
   */
    public static IsLoading(panel: IAdminToolPanel) {
        return panel && panel.isLoading ? panel.isLoading : false;
    }

    /**
    * Set search filters in the state
    * @static
    * @memberOf AdminToolPanelHelper
    */
    public static SetSearchFilters(adminToolState: any, panelName: string, word: string) {
        store.dispatch({
            type: types.SET_SEARCH_FILTERS,
            panelName: panelName,
            word: word
        });
    }

    /**
     * Set the paging number in the state
     * @static
     * @memberOf AdminToolPanelHelper
     */
    public static SetPaging(adminToolState: any, panelName: string, pagingNumber: number) {
        store.dispatch({
            type: types.SET_PAGING_NUMBER,
            panelName: panelName,
            pagingNumber: pagingNumber
        });
    }

    /**
   * Get the paging number from the state
   * @static
   * @memberOf AdminToolPanelHelper
   */
    public static GetPaging(panel: IAdminToolPanel): number {
        return panel && panel.listPaging ? panel.listPaging : 0;
    }

    /**
    *  Get a value from the panel state using a defined key
    * @static
    * @memberOf AdminToolPanelHelper
    */
    public static GetPanelValueFromState(panel: IAdminToolPanel, valueKey: string): any {
        return panel && panel.values ? panel.values[valueKey] : null;
    }

    /**
   *  Set a value in the panel state using a defined key
   * @static
   * @memberOf AdminToolPanelHelper
   */
    public static AddOrUpdatePanelValue(panelName: string, valueKey: string, value: any) {
        store.dispatch({
            type: types.ADD_OR_UPDATE_PANEL_VALUE,
            panelName: panelName,
            valueKey: valueKey,
            value: value
        });
    }


    /**
    *  Clear the panel error messages
    * @static
    * @memberOf AdminToolPanelHelper
    */
    public static ClearPanelErrorMessages(panel: IAdminToolPanel) {
        store.dispatch({
            type: types.CLEAR_PANEL_ERRORMESSAGES,
            panelName: panel.panelName
        });

        panel.errorMessages = [];
    }
    /**
   *  Add an error to the panel error messages state
   * @static
   * @memberOf AdminToolPanelHelper
   */
    public static AddErrorMessagesToState(panel: IAdminToolPanel, errorMessage: string) {
        store.dispatch({
            type: types.ADD_PANEL_ERRORMESSAGE,
            panelName: panel.panelName,
            errorMessage: errorMessage
        });
    }
    /**
     *  Works out if the panel should be displayed or not
     * @static
     * @memberOf AdminToolPanelHelper
     */
    public static IsPanelDisplayed(panel: IAdminToolPanel): boolean {
        if (!panel)
            return true;

        return (panel.isDisplayed != null) ? panel.isDisplayed : true;
    }
    /**
     *  Set is loading in the panel state
     * @static
     * @memberOf AdminToolPanelHelper
     */
    public static SetPanelIsLoading(panelName: string, isLoading: boolean) {
        store.dispatch({
            type: types.SET_PANEL_LOADING,
            panelName: panelName,
            isLoading: isLoading
        });
    }

    /**
   *  Get the panel from the state
   * @static
   * @memberOf AdminToolPanelHelper
   */
    public static GetPanel(adminToolState: any, panelName: string): IAdminToolPanel {
        let findThis: IAdminToolPanel = adminToolState.panels.filter((a) => {
            return a.panelName === panelName;
        })[0];

        return findThis ? findThis : null
    }
    
    /**
   *  Get all the error messages from the panel state
   * @static
   * @memberOf AdminToolPanelHelper
   */
    public static GetErrorMessagesFromState(panel: IAdminToolPanel) {
        if (!panel || !panel.errorMessages)
            return [];

        return panel.errorMessages;
    }

    /**
    *  Set up the panel state
    * @static
    * @memberOf AdminToolPanelHelper
    */
    public static SetUpPanelState(adminToolState: any, panelName: string, isDisplayed: boolean = false, setUp: boolean = true, isLoading: boolean = false) {
        let findPanel: IAdminToolPanel = adminToolState.panels.filter((a) => {
            return a.panelName === panelName;
        })[0];

        let errors: string[] = [];
        if (!findPanel) {
            let newPanel: IAdminToolPanel = {
                panelName: panelName,
                listPaging: 0,
                values: {},
                searchFilter: '',
                isDisplayed: isDisplayed,
                tabName: adminToolState.tab,
                errorMessages: errors,
                isLoading: isLoading
            };
            AdminToolPanelHelper.AddOrUpdatePanel(newPanel);
        }
        else if (!setUp) {
            findPanel.isDisplayed = isDisplayed;
            findPanel.isLoading = isLoading;
            AdminToolPanelHelper.AddOrUpdatePanel(findPanel);
        }
    }
}



// WEBPACK FOOTER //
// ./source/ts/helpers/admintoolpanelhelper.ts